import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import cx from "classnames";
const Video = ({
  srcs = [],
  showPagination = true,
  paginationButtons = [],
}) => {
  const [active, setActive] = useState(0);
  const [progress, setProgress] = useState(0);

  const handleActive = () => {
    setActive((current) => (current > srcs.length - 2 ? 0 : current + 1));
  };
  const handleChange = (index) => {
    if (index === active) return;
    setActive(index);
  };
  const handleTimeUpdate = (e) => {
    const { currentTime, duration } = e.currentTarget;
    if (!Number.isFinite(duration) || duration === 0) return;
    setProgress((currentTime / duration) * 100);
  };

  useEffect(() => {
    setProgress(0);
  }, [active]);

  return (
    <div className="relative w-full">
      <div className="relative aspect-video w-full overflow-hidden rounded-xl border border-white/10 bg-[#0b0b0b] shadow-[0_24px_70px_rgba(0,0,0,.45)] ring-1 ring-white/10 transition-[box-shadow,transform] duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_30px_90px_rgba(0,0,0,.55)]">
        <AnimatePresence mode="wait">
          {srcs.map((src, index) =>
            active === index ? (
              <motion.video
                initial={{ opacity: 0, scale: 0.985 }}
                animate={{
                  opacity: 1,
                  scale: 1,
                  transition: { type: "tween", duration: 0.28 },
                }}
                exit={{
                  opacity: 0,
                  scale: 0.99,
                  transition: { type: "tween", duration: 0.18 },
                }}
                key={index}
                src={src}
                className="h-full w-full object-cover max-sm:object-contain"
                onLoadedMetadata={() => setProgress(0)}
                onTimeUpdate={handleTimeUpdate}
                onEnded={handleActive}
                autoPlay
                muted
                playsInline
                controls={false}
              />
            ) : null
          )}
        </AnimatePresence>
      </div>
      {showPagination && (
        <div className="absolute left-1/2 z-50 mt-4 w-max -translate-x-1/2 max-sm:mt-3">
          <div className="inline-flex items-center justify-center gap-0.5 rounded-lg border border-white/10 bg-white/95 p-0.5 shadow-[0_16px_35px_rgba(0,0,0,.25)] backdrop-blur">
            {paginationButtons.map((btn, index) => (
              <button
                type="button"
                key={index}
                className={cx(
                  "flex min-w-[72px] max-sm:min-w-[66px] flex-col justify-between rounded-md px-2.5 py-1.5 text-left font-inter text-[11px] font-semibold transition-[background-color,box-shadow,transform,color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-slate-100 active:translate-y-0 active:scale-[0.98]",
                  {
                    "bg-[#E8F0FF] text-[#2441A8] shadow-sm": index === active,
                    "text-[#4b5563]": index !== active,
                  }
                )}
                onClick={() => handleChange(index)}
              >
                <span>{btn}</span>
                <div className="relative mt-1 h-[2px] w-full overflow-hidden rounded-full bg-[#D4D7DE]">
                  <motion.div
                    className="absolute left-0 top-0 h-full w-full origin-left rounded-full bg-[#2F5BFF]"
                    animate={{ scaleX: active === index ? progress / 100 : 0 }}
                    transition={{ type: "tween", duration: 0.12 }}
                  />
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Video;
